// 关于 主页顶部栏
export default {
  '语言':	'语言',
  '关于':	'关于',
  '用户中心':'用户中心',
  '运行环境':'运行环境',
  '最近更新日期':'最近更新日期',
  '广州里工实业有限公司':'广州里工实业有限公司',
  '电话':'电话',
  '电子邮件':'电子邮件',
  '网址':'网址',
}